import ReverbCookie from '../reverb_cookie';
import { CURRENCY_SYMBOLS as currencySymbols } from './constants';

const USD_CURRENCY = 'USD';
const CURRENCY_COOKIE_LOCATION = 'reverb_user_currency';

const userCurrency = ReverbCookie.get(CURRENCY_COOKIE_LOCATION) || USD_CURRENCY;

export default {
  currency: userCurrency,
  symbol: currencySymbols[userCurrency.toLowerCase()] || userCurrency,
};



// WEBPACK FOOTER //
// ./javascripts/components/shared/user_currency.js